import { Injectable } from '@angular/core';
import { ChartTypes } from '@mode/shared/contract-common';
import { LocalStorageService } from '@mode/shared/util-js';
import { Observable, map, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VizStorageService {
  private VIZ_STORAGE_KEY = 'mode-viz-storage';

  constructor(private localStorageService: LocalStorageService) {}

  public addViz(snapshot: ChartTypes.ChartSnapshot) {
    this.localStorageService.setStringifiedItem(`${this.VIZ_STORAGE_KEY}`, snapshot);
  }

  public getViz(): ChartTypes.ChartSnapshot | null {
    const item = this.localStorageService.getObject(`${this.VIZ_STORAGE_KEY}`);
    return item ? (item as ChartTypes.ChartSnapshot) : null;
  }

  //Hide and show paste option if local storage has en exisiting viz in storage
  public hasSavedViz() {
    return this.localStorageService.observeItem(`${this.VIZ_STORAGE_KEY}`).pipe(switchMap((item) => of(item != null)));
  }

  public getSavedVizSnapshot() {
    return this.localStorageService
      .observeItem(`${this.VIZ_STORAGE_KEY}`)
      .pipe(map((item) => item as ChartTypes.ChartSnapshot));
  }
}
